

// gio 点击
$(".gio-click-action").on('click', function () {
    var url = $(this).attr('data-url');
    var id = $(this).attr('data-id');
    var recommendposition = $(this).attr('data-position');
    if(url){
        toLinkUrl(url, recommendposition, id);
    }
})


//阻止标签点击冒泡 瀑布流加载后会再次执行，以防止新添加的元素不阻止
function stopRurnLik() {
    //todo author 这里为暂时不跳转
    $(".category-label, .author, .product-price, .filedown-box, .stop-propagation").on('click', function (event) {
        event.stopPropagation();
    });
}

stopRurnLik();


//点赞事件 参数：id=>文章id, status=>当前文章的点赞状态
function addLike(id, title, isTost) {
    event.stopPropagation();

    var thisDom = $('.act-like-' + id);
    var iconBox = $('.act-like-' + id + ' .like-icon');
    var likeNum = $('.act-like-' + id + ' .like-num');
    var status = thisDom.attr('data-status');

    //获取文章详情页的点赞
    var articleFooterIcon = $('.art_footer_like svg');
    var articleFooterNum = $('.like_footer_num');

    var usrInfo = isLogin();
    //判断是否登录
    var likeText = '点赞并收藏成功';
    var unLikeText = '点赞/收藏已取消';
    if (!usrInfo) {
        likeText = '点赞成功';
        unLikeText = '已取消点赞';

        //行为记录
        /*if (status === 'true') {
            userRecode({behaviorType: '取消收藏', behaviorResult: '无',});
        } else {
            userRecode({behaviorType: '收藏', behaviorResult: '无',});
        }
        common.gotoLogin();
        return;
        /!*if(confirm('您尚未登录，是否跳转到登录？')){
            window.location.href = window.cateData.url.loginAndBack;
        }else{
            return;
        }*!/*/

    }

    //行为记录
    if (status === 'true') {
        userRecode({behaviorType: '取消收藏', behaviorResult: '无',});
    } else {
        userRecode({behaviorType: '收藏', behaviorResult: '无',});
    }

    //如果点赞状态为true 则取消点赞
    if (status === 'true') {
        iconBox.removeClass('status-like-true');
        iconBox.addClass('status-like-false');
        thisDom.attr('data-status', 'false');
        changeLikeNum('cut');
    } else {
        iconBox.addClass('status-like-true');
        iconBox.removeClass('status-like-false');
        thisDom.attr('data-status', 'true');
        changeLikeNum('add');
        gioTrackAction.collect();
    }

    function changeLikeNum(type) {
        var status = type === 'add' ? 1 : 0;
        var behaviorType = type === 'add' ? '收藏' : '取消收藏';


        postJson(window.cateData.api.like, {articleId: id, status: status, sess: usrInfo.session}, function (data) {
            if (data.result > 0) {
                loginOut();
                return;
            } else {
                likeNum.text(data.total);
                //行为记录
                userRecode({behaviorType: behaviorType, behaviorResult: title});
                if(isTost){ //需要提示
                    if(behaviorType === '收藏') {
                        msg.toast(likeText);
                        gioTrackAction.collectSuccess();
                    }else{
                        msg.toast(unLikeText);
                    }
                }

                window.postMessage({type:'like', totle:data.total, status:status, id:id }, '*');

                /*if(behaviorType === '收藏') {
                    if(articleFooterIcon && articleFooterNum){
                        articleFooterIcon.addClass('article-tab-col');
                        articleFooterNum.addClass('article-tab-col');
                        articleFooterNum.text(data.total);
                    }
                }else{
                    if(articleFooterIcon && articleFooterNum){
                        articleFooterIcon.removeClass('article-tab-col');
                        articleFooterNum.removeClass('article-tab-col');
                        articleFooterNum.text(data.total);
                    }
                }*/
            }
        }, true);
    }

    //sess 不对需要登出
    function loginOut() {
        delCookie('smarketMember_' + window.cateData.schemaId);
        delCookie('OCSESSID');
        gio('clearUserId');
        //行为记录
        if (status === 'true') {
            userRecode({behaviorType: '取消收藏', behaviorResult: '无',});
        } else {
            userRecode({behaviorType: '收藏', behaviorResult: '无',});
        }
        common.gotoLogin();
    }
}

//解决ios返回读取缓存的问题
var browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
if (browserRule.test(navigator.userAgent)) {
    window.onpageshow = function (event) {
        if (event.persisted) {
            window.location.reload();
        }
    };
}

//处理时间
function handleTime() {
    //获取页面的时间戳
    var timeEleArr = document.querySelectorAll('.handle-time-box');
    timeEleArr.forEach(function (item, index) {
        var timestamp = parseInt(item.getAttribute('date-timestamp'));
        if (!timestamp) {
            return;
        }
        //处理时间

        var nowTime = parseInt(new Date().getTime() / 1000);

        var t = nowTime - timestamp;
        var res = '';

        if (t < 0 || !timestamp) {
            res = '';
        } else if (t < 3600) {
            res = parseInt(t / 60) + "分钟前";
        } else if (t >= 3600 && t < 86400) {
            res = parseInt(t / 3600) + "小时前";
        } else if (t >= 86400 && t < 864000) {
            res = parseInt(t / 86400) + "天前";
        } else {
            res = transformPHPTime(timestamp);
        }

        //设置时间
        item.innerText = res;
    });

    //时间戳转日期
    function transformPHPTime(time) {
        var date = new Date(time * 1000);

        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        /*var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();*/

        return Y + M + D;
    }

}

//时间戳转时间格式yyyy/MM/dd
function dateStampToTime(timestamp) {
    var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '/'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    return Y + M + D
}

//异步请求收藏数量，收藏状态，和评论数
function gettatInfo() {
    var handelArrEle = document.querySelectorAll('.handle-like-box');
    var articleIdArr = [];//要处理的文章id
    var elemArr = [];//需要处理的dom
    if (handelArrEle.length === 0) {
        return;
    }
    handelArrEle.forEach(function (item, index) {
        var articleId = item.getAttribute('data-articleid');
        articleIdArr.push(articleId);
        elemArr[articleId] = item;
    });

    var articleIdStr = articleIdArr.join(',');

    var option = {
        'uid': window.cateData.userInfo.memberId,
        'articleId': articleIdStr
    };
    var postUrl = window.cateData.api.getCollectionStatus;
    postJson(postUrl, option, function (data) {
        if (data.result > 0) {
            return;
        }
        data.content.forEach(function (item, index) {
            handelArrEle.forEach(function (ele, index) {
                var articleId = ele.getAttribute('data-articleid');
                if (articleId === item.id) {
                    var likeStateEle = ele.querySelector('.like-icon');
                    var likeNumEle = ele.querySelector('.like-num');
                    var commnetNumEle = ele.querySelector('.commnet-num');
                    var linkP = ele.querySelector('.like');
                    var browseNumEle = ele.querySelector('.browseNum');  //浏览量
                    if (likeStateEle) {
                        if (item.collect) {
                            likeStateEle.classList.remove('status-like-false');
                            likeStateEle.classList.add('status-like-true');
                            linkP.setAttribute('data-status', 'true');
                        } else {
                            likeStateEle.classList.remove('status-like-true');
                            likeStateEle.classList.add('status-like-false');
                            linkP.setAttribute('data-status', 'false');
                        }
                    }
                    if (likeNumEle) {
                        likeNumEle.innerText = item.collectCount;
                    }
                    if(commnetNumEle){
                        commnetNumEle.innerText = item.commentCount;
                    }
                    if(browseNumEle){
                        browseNumEle.innerText = item.browseCount;
                    }
                }
            });
        });
    }, true);
}

//屏蔽搜索页的滚动事件
$('.page-serach').on("touchmove", function (e) {
    e.preventDefault();
});

//单篇文章获取点赞状态
function getCollectionStatus(articleId, collectionEl, callback) {

    // collectionEl.className = 'collectionicon';

    collectionEl.classList.add('act-like-' + articleId);
    //设置id类
    var collectionIconEl = collectionEl.querySelector('.like-icon');

    var postUrl = window.cateData.api.getCollectionStatus;
    var option = {
        'uid': window.cateData.userInfo.memberId,
        'articleId': articleId
    };
    postJson(postUrl, option, function (data) {
        if (data.result > 0) {
            return;
        }
        if (data.content[0].collect) {
            collectionIconEl.classList.remove('status-like-false');
            collectionIconEl.classList.add('status-like-true');
            //设置状态
            collectionEl.setAttribute('data-status', 'true');
        } else {
            collectionIconEl.classList.remove('status-like-true');
            collectionIconEl.classList.add('status-like-false');
            //设置状态
            collectionEl.setAttribute('data-status', 'false');
        }
        if(typeof callback === 'function'){
            callback(data.content);
        }
        return data.content;
    }, true);
}

//关注 取消关注
var subscribe = function (authorId, authorName, status) {

    var bt = document.querySelector('.focusbt');
    var unbt = document.querySelector('.un-focusbt');
    //dom操作
    function setSubscribeBt() {
        unbt.classList.remove('hide');
        bt.classList.add('hide');
    }

    function setUnsubscribeBt() {
        bt.classList.remove('hide');
        unbt.classList.add('hide');
    }

    function loginStatus() {
        var usrInfo = isLogin();
        if (!usrInfo) {
            //行为记录
            if (status) {
                userAction.focusAuthor('无');
            } else {
                userAction.cancelFocusAuthor('无');
            }
            common.gotoLogin();
            return;
        }
    }

    var subscribeObj = {};
    var url = '';
    subscribeObj.do = function () {
        loginStatus();

        if(status){
          url = window.pcUrl + '/api/interaction/author/' + authorId + '/collect/' + 1;
          userAction.focusAuthor(authorName);
          setSubscribeBt();
        }else{
          url = window.pcUrl + '/api/interaction/author/' + authorId + '/collect/' + 0;
          userAction.cancelFocusAuthor(authorName);
          setUnsubscribeBt();
        }
        getJson(url, '',  function (data) {}, true);
    };
    return subscribeObj;
};

//商品数量的加减
//cutClass ：
function ProductNumCtr(cutClass, numClass, addClass, numLimit) {
    var cutEl = document.querySelector(cutClass);
    var numEl = document.querySelector(numClass);
    var addEl = document.querySelector(addClass);

    if(!cutEl || !numEl || !addEl){
        return;
    }

    var _this = this;

    this.num = 1;

    this.cut = function () {
        if(_this.num > 1) {
            _this.num -= 1;
        }
        _this.setNum();
    };

    this.add = function () {
        if(numLimit){
            if(_this.num >= numLimit){
                return;
            }
        }
        _this.num += 1;
        _this.setNum();
    };

    this.setNum = function (num) {
        if(!num){
            numEl.textContent = _this.num;
        }else{
            if(numLimit && num >= numLimit){
                num = numLimit;
            }
            _this.num = num;
            numEl.textContent = _this.num;
        }
    };

    this.getNum = function () {
        return _this.num;
    };

    this.destroy = function () {
        cutEl.removeEventListener('click',  _this.cut);
        addEl.removeEventListener('click', _this.add);
        numLimit = null;
    };


    cutEl.addEventListener('click',  _this.cut);
    addEl.addEventListener('click', _this.add);

    return {
        getNum: this.getNum,
        setNum: this.setNum,
        cut: this.cut,
        add: this.add,
        destroy: this.destroy
    };

}

//loading 透明
var pageLoading = {
    show:function () {
        $('.load-opa').show();
    },

    close: function () {
        $('.load-opa').hide();
    }
};
//loading 不透明
var globalLoading = {
    show:function () {
        $('.page-home').hide();
        $('.load').show();
    },

    close: function () {
        $('.page-home').show();
        $('.load').hide();
    }
};

//原生滚动动画
function scrollAnimation(currentY, targetY) {
    // 获取当前位置方法
    // var currentY = document.documentElement.scrollTop || document.body.scrollTop;

    // 计算需要移动的距离
    var needScrollTop = targetY - currentY;
    var _currentY = currentY;
    setTimeout(function () {
        // 一次调用滑动帧数，每次调用会不一样
        var dist = Math.ceil(needScrollTop / 10);
        _currentY += dist;
        window.scrollTo(_currentY, currentY);
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
            scrollAnimation(_currentY, targetY);
        } else {
            window.scrollTo(_currentY, targetY);
        }
    }, 1);
}

//返回逻辑
// 如果上一页地址为空
function goBack(url) {
  if(document.referrer === '' || document.referrer.indexOf(solution_m_host) === -1){ //如果上一页为空或不是手机端的页面

      if(url){
          window.location.href = window.rootUrl + url;
      }else{
          //根据所在页面设置返回链接
          if(window.cateData.pageModule === 'user'){ //如果是用户中心 返回到用户中心首页
              window.location.href = window.rootUrl + '/user/index.html';
          }else if(window.cateData.pageModule === 'author'){ //如果是作者主页 返回到作者主页首页
              window.location.href = window.rootUrl + '/author/' + window.authorId;
          }else{ //返回到首页
              window.location.href = window.rootUrl;
          }
      }
  }else{
    window.history.back();
  }
}

//事件添加方法
function addEvent(obj,type,fn){
    if(obj.attachEvent){ //ie
        obj.attachEvent('on'+type,function(){
            fn.call(obj);
        })
    }else{
        obj.addEventListener(type,fn,false);
    }
}

/**
 * 处理iOS 微信客户端6.7.4 键盘收起页面未下移bug
 */

function fixIosBug(){
    setScroll.removeUnScroll();
    setScroll.unScroll();
}

/**
 * 处理iOS Safari 缓存问题
 */

var isWx = !!navigator.userAgent.match(/MicroMessenger.+?([\d.]+)/i);
if (navigator.userAgent.indexOf("Safari") > -1 || isWx) {
    window.onpageshow = function(event) {
        if (event.persisted) {
            document.body.style.display = "none";
            window.location.reload();
        }
    };
}
